<ng-container *transloco="let t">
  <button
    type="button"
    class="flex items-center gap-1.5 rounded-lg px-3 py-2 -mx-2 font-medium cursor-pointer focus:outline-none"
    (click)="onClick()?.(); $event.stopPropagation()"
    [class]="statusHoverClasses()"
  >
    <mat-icon [svgIcon]="statusIcon()" [style.color]="statusColor()" class="size-4!"></mat-icon>
    @if (status() === orderStatus.InProgress) {
    <p [style.color]="statusColor()">
      @if (isRtl()) {
      {{ recipientsCount()! | translocoDecimal : { useGrouping: false } }}/{{
        completedCount()! | translocoDecimal : { useGrouping: false }
      }}
      } @else {
      {{ completedCount()! | translocoDecimal : { useGrouping: false } }}/{{
        recipientsCount()! | translocoDecimal : { useGrouping: false }
      }}
      }
      {{ t('ORDER-DETAILS.DONE') }}
    </p>
    } @else {
    <p [style.color]="statusColor()">{{ statusLabelKey() | transloco }}</p>
    }
  </button>
</ng-container>
